// BAG CRAP: slim "added to bag" bar on collection pages (Amanda approved Oct 18, 2026).
// - A "+ Add" on a collection card shows this bar instead of opening the full bag.
// - The bar stays at the bottom of collection pages while the bag has items.
// - Tapping the bar opens the full bag; Checkout goes straight to checkout.
// Product pages and the homepage keep the full bag (this file only loads on collection pages).
// Compact mode (Amanda approved, Oct 18, 2026): the bar rests as a small bag circle in the bottom-right corner
// (photo, count, total). Tap it to expand into the full bar; the × shrinks it back. After "+ Add" it expands
// for about 4 seconds as confirmation, then shrinks. While it's expanded the 10% circle steps aside.
(function () {
  var cart = document.getElementById("side-cart");
  if (!cart) return;

  var expectAddUntil = 0; // set when a card "+ Add" that will really add is tapped
  var lastBtn = null;

  // ---- Markup ----
  var bar = document.createElement("div");
  bar.id = "bag-bar";
  bar.setAttribute("role", "region");
  bar.setAttribute("aria-label", "Bag");
  bar.innerHTML =
    '<button type="button" class="bb-open" aria-label="Open bag">' +
      '<span class="bb-thumb"><img alt="" width="40" height="40"><span class="bb-count"></span></span>' +
      '<span class="bb-text"><span class="bb-l1"></span><span class="bb-l2"></span>' +
      '<span class="bb-prog" hidden><span class="bb-fill"></span></span></span>' +
      '<span class="bb-mtotal"></span>' +
    "</button>" +
    '<a href="/checkout" class="bb-checkout">Checkout</a>' +
    '<button type="button" class="bb-close" aria-label="Shrink bag bar"><span aria-hidden="true">&times;</span></button>';
  document.body.appendChild(bar);

  var img = bar.querySelector(".bb-thumb img");
  var count = bar.querySelector(".bb-count");
  var l1 = bar.querySelector(".bb-l1");
  var l2 = bar.querySelector(".bb-l2");
  var prog = bar.querySelector(".bb-prog");
  var fill = bar.querySelector(".bb-fill");
  var mtotal = bar.querySelector(".bb-mtotal");
  var openBtn = bar.querySelector(".bb-open");

  // ---- Compact (circle) vs expanded (full bar) ----
  var expanded = false, autoT = null, lastTotal = null;
  var setExpanded = function (on, auto) {
    clearTimeout(autoT);
    expanded = on;
    bar.classList.toggle("is-open", on);
    document.body.classList.toggle("bag-bar-open", on && bar.classList.contains("is-on"));
    openBtn.setAttribute("aria-label", on ? "Open bag" : "Show bag summary");
    openBtn.setAttribute("aria-expanded", on ? "true" : "false");
    if (on && auto) autoT = setTimeout(function () { setExpanded(false); }, 4000);
    // Once it shrinks, drop the one-time "Added ·" / "Already in your bag" wording so a later tap shows the plain total
    if (!on && lastTotal !== null) l1.textContent = "Bag " + money(lastTotal);
  };

  // Free-shipping threshold comes from the bag's own banner (US shoppers only).
  var shipEl = cart.querySelector(".shipping-threshold");
  var threshold = shipEl ? Number(shipEl.dataset.threshold) * 100 : 0;

  var money = function (cents) {
    var v = cents / 100;
    return "$" + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  };

  var drawerOpen = function () { return cart.classList.contains("active"); };

  var setVisible = function (on) {
    // Theme previews only: sit above Shopify's preview banner (shoppers never see that banner)
    if (document.getElementById("PBarNextFrame")) bar.style.bottom = "72px";
    bar.classList.toggle("is-on", on);
    document.body.classList.toggle("bag-bar-on", on);
    document.body.classList.toggle("bag-bar-open", on && expanded);
  };

  var render = function (data, justAdded, note) {
    if (!data || !data.item_count) { setVisible(false); return; }
    var first = data.items[0]; // newest line first
    if (first && first.image) {
      img.src = first.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x120$1$2");
      img.hidden = false;
    } else {
      img.hidden = true;
    }
    count.textContent = data.item_count;
    mtotal.textContent = money(data.total_price);
    lastTotal = data.total_price;
    l1.textContent = note ? note : (justAdded ? "Added · " : "") + "Bag " + money(data.total_price);
    if (threshold > 0) {
      var left = threshold - data.total_price;
      l2.textContent = left > 0 ? money(left) + " to free shipping" : "Free shipping unlocked";
      fill.style.width = Math.min(100, Math.round((data.total_price / threshold) * 100)) + "%";
      prog.hidden = false;
    } else {
      l2.textContent = data.item_count + (data.item_count === 1 ? " item" : " items");
      prog.hidden = true;
    }
    bar.classList.toggle("just-added", !!justAdded);
    clearTimeout(bar._t);
    if (justAdded) bar._t = setTimeout(function () { bar.classList.remove("just-added"); }, 2500);
    setVisible(!drawerOpen());
    if (justAdded || note) setExpanded(true, true); // confirmation, then shrink back
  };

  var refresh = function (justAdded, note) {
    return fetch("/cart.js", { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) { return r.json(); })
      .then(function (data) { render(data, justAdded, note); })
      .catch(function () {});
  };

  // ---- A card "+ Add" that will really add (option chosen and in stock) ----
  document.addEventListener("click", function (event) {
    var btn = event.target.closest(".plp-atc-btn");
    if (!btn || !btn.closest(".product")) return;
    if (!btn.dataset.atcId || parseInt(btn.dataset.stock, 10) === 0) return; // "Pick one" / sold out: unchanged
    expectAddUntil = Date.now() + 6000;
    lastBtn = btn;
  }, true);

  // main.js opens the full bag after a card add. Close it before it paints and show the bar instead.
  var wasOpen = drawerOpen();
  new MutationObserver(function () {
    var open = drawerOpen();
    if (open === wasOpen) return; // other class changes (e.g. "empty") don't matter here
    wasOpen = open;
    if (open) {
      if (Date.now() < expectAddUntil) {
        expectAddUntil = 0;
        cart.classList.remove("active", "animate-lg");
        wasOpen = false;
        document.body.classList.remove("prevent-scroll");
        // Shopify refused the add (all in stock already in the bag): add-feedback.js flashes the card;
        // the bar says so instead of "Added".
        var refused = window.bcAddRefused && Date.now() - window.bcAddRefused.t < 6000;
        if (refused) {
          var why = window.bcAddRefused.text || "Already in your bag";
          window.bcAddRefused = null;
          refresh(false, why);
        } else {
          flashAdded(lastBtn);
          refresh(true);
        }
      } else {
        setVisible(false); // shopper opened the bag themselves
      }
    } else {
      refresh(false); // bag closed: items may have been removed or added there
    }
  }).observe(cart, { attributes: true, attributeFilter: ["class"] });

  // "✓ Added" on the card for a moment. The theme hides plain button text and paints "+ Add" over it
  // (span:not([style])), so this label carries its own inline style, like cart.js's "Pick one".
  function flashAdded(btn) {
    if (!btn) return;
    if (!btn.dataset.bbIcon) btn.dataset.bbIcon = btn.innerHTML;
    btn.innerHTML = '<span class="bb-added" style="font-size:13px;letter-spacing:1px;white-space:nowrap;font-family:Parkinsans,sans-serif;font-weight:800;text-transform:uppercase;color:#fff;opacity:1;animation:none;">&#10003; Added</span>';
    clearTimeout(btn._bbT);
    btn._bbT = setTimeout(function () { btn.innerHTML = btn.dataset.bbIcon; }, 2500);
  }

  // ---- Bar taps ----
  openBtn.addEventListener("click", function () {
    if (!expanded) { setExpanded(true, false); return; } // circle: first tap expands
    setExpanded(false);
    setVisible(false);
    cart.classList.add("active", "animate-lg");
    document.body.classList.add("prevent-scroll");
  });

  bar.querySelector(".bb-close").addEventListener("click", function () { setExpanded(false); });

  // Same as the bag's Checkout button: save any order note first.
  bar.querySelector(".bb-checkout").addEventListener("click", function (event) {
    event.preventDefault();
    var note = document.querySelector("#gift-note");
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note: note ? note.value.trim() : "" }),
    })
      .catch(function () {})
      .then(function () { window.location.href = "/checkout"; });
  });

  // First load, and Safari's swipe-Back restore (page comes back from memory with an old bar)
  refresh(false);
  window.addEventListener("pageshow", function (e) { if (e.persisted) refresh(false); });
})();
